module.exports = __webpack_public_path__ + "img/venuetwo-jkzsdt.78625bf7.png";